import { useSelector } from "react-redux";
import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
// import AdminHeader from "./AdminHeader";

import useStyles from "../Styles";
import { useMediaQuery } from "@material-ui/core";
import HeaderView from "./HeaderView";
import HeaderViewResponsive from "./HeaderViewResponsive";
import Visuals from "./Visuals";
import SettingsVisuals from "./SettingsVisuals";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
// import ToolbarButtons from "./ToolbarButtons";

const HeaderContainer = ({ adminHeader }) => {
  const { loggedIn } = useSelector((state) => state.auth);
  const { isMobile } = useGetViewPortDimensions();

  const classes = useStyles();
  // const [anchorEl, setAnchorEl] = React.useState(null);

  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  // const open = Boolean(anchorEl);
  // const id = open ? "user-settings" : null;
  return loggedIn && adminHeader ? (
    <AppBar
      position="fixed"
      elevation={0}
      className={matches ? classes.appBar : ""}
      color="transparent"
    >
      <Toolbar className={classes.toolbar}>
      {isMobile ? <HeaderViewResponsive /> : <HeaderView />}
        {/* <ToolbarButtons /> */}
      </Toolbar>
      <SettingsVisuals />
    </AppBar>
  ) : (
    <AppBar position="fixed" elevation={0} color="transparent">
      <Toolbar className={classes.toolbar}>
        {isMobile ? <HeaderViewResponsive /> : <HeaderView />}
      </Toolbar>
      {/* {isMobile ? <Visuals /> : null} */}
      <Visuals />
    </AppBar>
  );
};

export default HeaderContainer;
